import { monthDiff, scaleZoom1, scaleZoom2, scaleZoom3 } from '../utils';
import { Chart, Container } from './styles';
import { useRef, useState } from 'react';
import { initFirstRow, initGanttRows, initSecondRow } from './Rows';
import useDraggableScroll from '../../../hooks/useDraggableScroll';
import { ThemeProvider } from 'styled-components';


function getLateTask(jobs, maxDate) {

  let lateTask = jobs.find((item) => item.status === 'late');
  let lastTaskDate;

  // Verificar até onde o gráfico deve ser gerado
  // É preciso verificar qual tarefa mais a direita para determinar
  // onde o grafico deve parar

  if (lateTask) {
    let today = new Date(); //Today
    today.setDate(today.getDate() + 10);
    lastTaskDate = new Date(maxDate.setDate(maxDate.getDate() + 10));
    if (today.getTime() > lastTaskDate.getTime()) lastTaskDate = today;
  } else {
    lastTaskDate = new Date(maxDate.setDate(maxDate.getDate() + 10));
  }


  return lastTaskDate;

}


function getMaxMinDate(jobs) {

  const minDate = new Date(
    Math.min(
      ...jobs.map((element) => {
        return new Date(element.start);
      })
    )
  );

  const maxDate = new Date(
    Math.max(
      ...jobs.map((element) => {
        return new Date(element.end);
      })
    )
  );

  return { minDate, maxDate }
}



export function Timeline({ jobs = [], zoom }) {

  const { minDate, maxDate } = getMaxMinDate(jobs)

  const lastTaskDate = getLateTask(jobs, maxDate);

  const theme = zoom === 1 ? scaleZoom1 : zoom === 2 ? scaleZoom2 : scaleZoom3;

  const [date] = useState({
    dateFrom: minDate,
    dateTo: lastTaskDate,
  });

  const first_month = new Date(
    date.dateFrom.getFullYear(),
    date.dateFrom.getMonth(),
    1
  );
  const last_month = new Date(
    date.dateTo.getFullYear(),
    date.dateTo.getMonth(),
    1
  );

  const actualDate = new Date();
  const n_months = monthDiff(first_month, last_month) + 1;

  const chartRef = useRef(null);

  const MonthRow = () => initFirstRow(first_month, last_month, actualDate);
  const DaysRow = () =>
    initSecondRow({
      first_month,
      last_month,
      minDate,
      currentDate: actualDate,
      jobs: jobs,
      dateTime: date,

    });

  const GanttRows = () =>
    initGanttRows({ first_month, last_month, jobs, theme, dateTime: date, ganttContainer: chartRef });


  const { onMouseDown } = useDraggableScroll(chartRef, 'horizontal');



  const axisJobsStyle = {
    gridTemplateColumns: `${theme.axisResourceWidth} repeat(${n_months},1fr)`,

  }


  return (
    <ThemeProvider theme={theme}>
      <Container>
        <Chart
          onMouseDown={onMouseDown}
          ref={chartRef}
          id="gantt-container"
          style={axisJobsStyle}
        >
          <MonthRow />
          <DaysRow />
          <GanttRows />
        </Chart>

      </Container>

    </ThemeProvider>
  );
}
